module.exports = __webpack_public_path__ + "img/15.c0b219c4.png";